import { Box, TextField } from '@mui/material'
import { createFyaItem } from 'api/services/automation/income-tax'
import DialogWrapper from 'components/DialogWrapper'
// import FormSelect from 'components/FormFields/FormSelect'
import LoadingButton from 'components/LoadingButton'
import { snack } from 'components/toast'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'
import { getFinancialYears } from 'utils/getFinancialYears'
import { handleError } from 'utils/handleError'

let addFyaItem = {
  name: "",
  assessmentYear: "",
  section: "",
  proceedingName: "",
  panNumber: "",
  type: "Self"
}

interface fyaItem {
  assessmentYear: string;
  section: string;
  proceedingName: string;
  panNumber: string;
  type: string
}

const CreateClientFya = ({ open, setOpen, profiledata }) => {
  const queryClient = useQueryClient()
  const params = useParams();
  const { control, handleSubmit, reset } = useForm<fyaItem>({
    defaultValues: addFyaItem,
    mode: "onChange"
  })

  const { mutate, isLoading } = useMutation(createFyaItem, {
    onSuccess: () => {
      snack.success("Fya Proceeding Added")
      queryClient.invalidateQueries("client-proceeding-fya")
      reset()
      setOpen(false)
    },
    onError: (error) => {
      snack.error(handleError(error))
    }
  })

  const onSubmit = async (item) => {

    if (item?.panNumber && item?.panNumber?.trim().length < 1) {
      return snack.error("Pan number is not found")
    }
    if (item?.proceedingName && item?.proceedingName?.trim().length < 1) {
      return snack.error("Proceeding Name is mandatory")
    }
    item.proceedingName = item?.proceedingName.trim()
    if (item?.assessmentYear && item?.assessmentYear?.trim().length < 1) {
      return snack.error("Assessment Year is mandatory")
    }

    mutate({
      ...item,
      pannumber: item?.panNumber?.trim(),
      autCreadentials: params.incometaxid
    })
  }

  useEffect(() => {
    if (open) {
      reset({
        type: "Self",
        panNumber: profiledata?.data?.profileDetails?.pan || "",
      })
    }
  }, [open])
  return (
    <DialogWrapper open={open} setOpen={setOpen} title='Add Manual Notice'>
      <form onSubmit={handleSubmit(onSubmit)}>

        {/* <Box mt={1}>
          <FormSelect
            control={control}
            name="type"
            label="Type" c
            size='medium'
            required
            options={["Self", "Other"]?.map((item) => ({
              label: item,
              value: item,
            }))}
          />
        </Box> */}
        <Box mt={1}>
          <TextField
            label="Name"
            fullWidth
            size='medium'
            value={profiledata?.data?.profileDetails?.name}
            disabled
          />
        </Box>
        {/* <Box mt={1}>
          <TextField
            label="PAN"
            fullWidth
            size='medium'
            {...control.register(`panNumber` as const)}
          />
        </Box> */}
        <Box mt={1}>
          <TextField
            label="Section"
            fullWidth
            size='medium'
            {...control.register(`section` as const)}
          />
        </Box>
        <Box mt={1}>
          <TextField
            label="Proceeding Name"
            size='medium'
            fullWidth
            required
            {...control.register(`proceedingName` as const)}
          />
        </Box>
        {/* <Box mt={1}>
          <FormSelect
            control={control}
            name="assessmentYear"
            label="Assessment Year"
            size='medium'
            required
            options={getFinancialYears().map((item) => ({
              label: item,
              value: item,
            }))}
          />
        </Box> */}
        <Box mt={1}>
          <LoadingButton
            loading={isLoading}
            disabled={isLoading}
            loadingColor='white'
            type="submit"
            title='Submit'
            color='secondary'
          />
        </Box>
      </form>
    </DialogWrapper>
  )
}

export default CreateClientFya